import { Space_Status_Enum, userService } from '@fortunecms/services'
import { Space_User_Status_Enum, User_Role_Enum } from 'src/types/custom-generated'

type Role = { space: string; role: string; status?: string }
type SpaceRow = { id: string; name: string; status: string; info: any; meta: any; invite_id?: string | null; created_at?: string }
type Contributor = { id: string; roles: Role[] | null; [key: string]: any }

export type UserSpace = SpaceRow & { uuid: string; user_role: string; user_status: string; contributors: Contributor[] }

const ownerRoles: string[] = [User_Role_Enum.SpaceOwner, User_Role_Enum.Admin]

export const loadUserSpaces = async (roles: Role[] | null | undefined): Promise<{ personalSpaces: UserSpace[]; contributedSpaces: UserSpace[] }> => {
    const active = new Map<string, Role>()
    for (const role of roles || []) {
        if (!role?.space || active.has(role.space)) continue
        if ((role.status || Space_User_Status_Enum.Active) !== Space_User_Status_Enum.Active) continue
        active.set(role.space, role)
    }
    const ids = Array.from(active.keys())
    if (!ids.length) return { personalSpaces: [], contributedSpaces: [] }

    const { spaces, contributors } = await userService.getUserSpaceRows({
        ids,
        members: { _or: ids.map((id) => ({ roles: { _contains: [{ space: id }] } })) },
    })
    const byId = new Map<string, SpaceRow>((spaces as SpaceRow[]).map((s) => [s.id, s]))
    const list = ids.flatMap((id): UserSpace[] => {
        const space = byId.get(id)
        const role = active.get(id)
        if (!space || !role || space.status === Space_Status_Enum.Deleted) return []
        return [{
            ...space,
            uuid: space.id,
            user_role: role.role,
            user_status: role.status || Space_User_Status_Enum.Active,
            contributors: (contributors as Contributor[]).filter((u) => (u.roles || []).some((r) => r.space === id)),
        }]
    })
    return {
        personalSpaces: list.filter((s) => ownerRoles.includes(s.user_role)),
        contributedSpaces: list.filter((s) => !ownerRoles.includes(s.user_role)),
    }
}
